import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import 'bootstrap/js/src/collapse';

const Navbar = () => {
	const location = useLocation();
	return (
		<nav
			className='navbar navbar-expand-lg navbar-light bg-light'
			style={{ display: location.pathname === '/login' && 'none' }}>
			<div className='container-fluid'>
				<Link className='navbar-brand' to='/'>
					DAB Wheels
				</Link>
				<button
					className='navbar-toggler'
					type='button'
					data-bs-toggle='collapse'
					data-bs-target='#navbarNav'
					aria-controls='navbarNav'
					aria-expanded='false'
					aria-label='Toggle navigation'>
					<span className='navbar-toggler-icon'></span>
				</button>
				<div className='collapse navbar-collapse' id='navbarNav'>
					<ul className='navbar-nav'>
						<li className='nav-item'>
							<NavLink className='nav-link' activeClassName='active' exact to='/'>
								Acasa
							</NavLink>
						</li>
						<li className='nav-item'>
							<NavLink className='nav-link' activeClassName='active' to='/taskuri'>
								Taskuri
							</NavLink>
						</li>
						<li className='nav-item'>
							<NavLink className='nav-link' activeClassName='active' to='/istoric'>
								Istoric
							</NavLink>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
};

export default Navbar;
